import { ScoreInfo } from "./Info";
import { Neighborhood } from "./Neighborhood";

export interface Property {
    addresses: Address[],
    createBy: number,
    createdUtc: Date,
    id: string | null,
    internalId: number,
    landlordId: number,
    neighborhoodId: number,
    calcScore: number,
    neighborhood: Neighborhood,
    landlord: Landlord,
    scoreInfo: ScoreInfo[]
    score: number
}

export interface Landlord{
    id: string,
    internalId: number,
    name: string,
    scoreInfo: ScoreInfo[]
}

export interface Address{
    address: string,
    masterAddress: string,
    block: number,
    lot: number,
    borough: number,
    city: string,
    heading: number,
    createdBy: number,
    createdUtc: Date,
    id: string | null,
    internalId: number,
    lat: number,
    lng: number,
    streetLat: number,
    streetLng: number,
    modifiedBy: number,
    propertyId: number,
    state: string,
    zip: string
}

export interface PropertyOwnershipClaim {
    internalId: number,
    addressId: number,
    status: ClaimStatus,
    notes: string,
    userId: number,
    user?: {
        internalId: number,
        firstName: string,
        lastName: string,
        company: string,
    }
    address?: Address
    property?: Property
    docs?: any[]
    statusUpdatedUtc?: Date
    statusUpdatedByName?: string
}

export interface PropertyPin {
    internalId: number;
    lat: number;
    lng: number;
    address: string;
    city: string;
    state: string;
    zip: string;
    calcScore: number;
    neighborhoodId: number;
    masterAddress: string
}

export enum ClaimStatus {
    Pending = 0,
    Accepted = 1,
    Rejected = 2
}